import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>
        【ログインIDがわからない場合】
        <br />
        COREのデジタル教材メニュー［生徒個別データ］から確認できます。
        <br />
        ※学校管理者の権限をお持ちの先生は、学校管理画面［生徒登録］からも一覧で確認することができます。
      </p>
    </div>
    <div>
      <p className={styles.heading}>【パスワードを忘れた場合】</p>
      <p className={styles.text}>
        COREのデジタル教材メニュー［生徒個別データ］、もしくは学校管理画面［生徒登録］から、パスワードを再発行し、生徒に共有してください。
      </p>
    </div>
  </div>
);

export const STUDENT_LOGIN_CREDENTIALS_FAQ: FaqCategoryItem = {
  id: "student-login-credentials-faq",
  question: "生徒のログインIDがわからない／生徒がパスワードを忘れてしまった",
  Answer,
};
